var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinaryRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.793 25.7788L113.414 27.2998H110.669L109.626 28.2568H101.63V29.0458H105.375L106.332 29.6638V31.2418L108.102 32.4733",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.627 28.2568L110.753 29.5243V32.1988",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.16 27.2999V29.2709H113.569L115.033 30.2279H116.948",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.475 25.1819L104.968 25.9619H106.023L106.657 27.2999H110.67",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0527 15.9944H78.1057L79.4722 14.9384L87.1582 14.2634",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8498 17.079H82.7663H79.8938V15.7155H84.8498V17.079Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7666 15.7153V17.0788",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M102.644 35.7749C103.002 35.7749 103.292 35.4848 103.292 35.1269C103.292 34.7691 103.002 34.4789 102.644 34.4789C102.286 34.4789 101.996 34.7691 101.996 35.1269C101.996 35.4848 102.286 35.7749 102.644 35.7749Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9822 29.9999L77.5297 31.6079V36.2639",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0527 29.8904C71.0527 29.8904 72.0097 31.3094 72.0097 31.3604V34.7684",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7313 30.9929V33.6914H86.9043V35.6624H77.5293",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2793 24.6809V28.3484",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5889 24.6809V28.3484",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8938 24.6809V28.3484",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7749 26.1733H70.5889",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4828 32.5934C87.6286 32.5934 87.7467 32.4752 87.7467 32.3294C87.7467 32.1836 87.6286 32.0654 87.4828 32.0654C87.3369 32.0654 87.2188 32.1836 87.2188 32.3294C87.2188 32.4752 87.3369 32.5934 87.4828 32.5934Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6087 23.2454H24.0322V25.8989H25.6087V23.2454Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9827 23.2454H38.4062V25.8989H39.9827V23.2454Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0803 34.7684V32.1989",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M105.601 24.0615V23.4135H114.554L112.724 25.611",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6359 21.9285L88.7344 23.0475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M86.005 19.8389L84.709 21.1334",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104.038 26.8064H100.406",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0982 26.5154H91.1992",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M71.0527 16.2899V14.8439C71.0527 14.1644 71.5717 13.5974 72.2497 13.5389C73.5682 13.4234 74.8867 13.3079 76.2052 13.1924H86.1442C86.5432 13.6049 86.7592 13.8299 87.1582 14.2424L87.1012 15.8954C86.7442 16.1114 86.3872 16.3274 86.0317 16.5434C85.8532 16.8254 85.6747 17.1059 85.4962 17.3879C84.4072 17.5289 83.3182 17.6699 82.2307 17.8109C81.2917 18.1394 80.3542 18.4679 79.4152 18.7964H74.3467C74.2927 18.4694 74.2597 17.9204 73.8397 17.5574C72.7972 16.6559 71.2612 16.2869 71.0527 16.2899V16.2899Z",
    fill: "#FAFAFB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3567 28.1789H13.5082L12.6217 27.9464H3.4252C3.2797 27.9464 3.1612 28.0649 3.1612 28.2104C3.1612 28.3559 3.2797 28.4744 3.4252 28.4744H5.6527V29.0864H3.3382C3.1357 29.0864 2.9707 29.2514 2.9707 29.4539C2.9707 29.5664 3.0607 29.6564 3.1732 29.6564H4.6387V29.9984H5.9557V31.2119L24.3127 32.3654L53.5672 32.7179L54.3697 33.0134L54.3277 33.3929H52.5532V33.9839L57.1987 34.7654H73.4602C73.7662 34.7654 74.0677 34.8269 74.3482 34.9484L81.5332 38.0354C81.8632 38.1764 82.2172 38.2499 82.5757 38.2499H87.5647C87.8212 38.2499 88.0297 38.0414 88.0297 37.7849H101.38C101.681 37.7849 101.977 37.7009 102.233 37.5419L102.728 37.2359L104.459 36.4754H105.409C105.703 36.4754 105.994 36.4229 106.268 36.3194L114.215 33.3494H114.68L116.396 32.6894C116.678 32.5814 116.861 32.3084 116.854 32.0054C116.839 31.4534 116.851 30.6149 117.046 30.3929C117.341 30.0554 117.046 29.5904 117.046 29.5904L115.864 29.2529L115.822 26.1704L116.287 25.7609L115.949 23.6789L114.514 22.2854L113.824 22.0889L113.317 21.6104H106.363L105.968 21.9479H99.6052L98.4232 21.3989L96.6067 21.3569L96.0157 20.3144L94.7062 18.3569L93.8617 17.8499L90.9472 17.9339C90.7447 17.6054 90.3562 17.4404 89.9797 17.5214L82.8382 19.0739L81.6562 19.7489L74.2237 20.3399L72.8302 20.8184H70.3237L24.7672 22.2269L23.6407 22.8464L22.1197 23.2409L15.2632 23.5724C15.2632 23.5724 10.9342 23.5094 10.7332 23.6354C10.5607 23.7449 10.5862 23.8769 10.5982 24.1619C10.6072 24.3644 10.7737 24.5234 10.9747 24.5234H11.5672C11.5252 25.7699 12.4117 25.8959 12.4117 25.8959H26.0737L26.8762 25.6079H37.0117L37.6447 25.9169L47.0212 25.7909L47.4007 26.5934L44.4022 27.8189",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3564 28.1788L25.1014 27.8203H53.3689L56.2984 27.2998H68.5744L69.0799 28.0603V28.4818H70.8259L71.5864 28.7923H81.1595V27.2998H83.891L85.2005 27.8203H89.381L87.4805 29.1718H79.118L77.8505 30.5233L82.7509 31.7488H85.5799L86.4244 31.0723L87.6919 30.8188L87.4805 29.1718",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M77.006 28.7922L75.698 29.9997H65.096L62.942 30.8187H60.0785L58.001 32.3397H69.911L69.743 29.9997",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5669 32.7193L57.4519 30.5653H53.3134L52.1734 29.9998H36.2509L34.9414 30.5653L19.3564 30.3928V32.0563",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1162 23.2454L47.1047 22.8374L49.0892 23.2454L67.5032 23.0414L85.2977 22.5134L87.8312 20.0924C87.8312 20.0924 88.2542 19.4174 87.8312 19.0229C87.4082 18.6284 87.2162 18.1259 85.9067 18.4109",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4104 18.627C87.4104 18.627 88.9029 18.318 89.1564 18.7965C89.4099 19.275 89.7189 20.2605 89.7189 20.2605L91.9989 21.978V23.865L84.0594 24.822L83.4684 25.329L80.8779 25.182L79.0479 24.09C79.0479 24.09 74.1489 24.2025 74.0649 24.2025C73.9809 24.2025 72.8829 24.681 72.8829 24.681H67.7019L66.9414 24.2865L67.5039 23.04",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4688 25.3289L89.3817 25.6664L92.5347 24.5969L96.4212 24.4559L97.3212 25.1819H104.473L105.6 24.4559H110.47L111.738 25.7789H113.793L114.948 24.8774L115.947 23.6819",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0508 16.1113V14.3068C71.0508 13.9303 71.3373 13.6153 71.7108 13.5808L75.7803 13.1938H86.1423L86.6688 13.5028C86.9358 13.6603 87.1008 13.9468 87.1008 14.2573V15.8968L86.0313 16.5448L85.4958 17.3893L82.2303 17.8123L81.7518 18.3283L80.0913 18.5308L79.7823 18.7978H74.9523C74.5983 18.7978 74.2908 18.5548 74.2083 18.2098L74.0943 17.7283L72.6858 16.8553L71.6223 16.7458C71.2983 16.7128 71.0523 16.4398 71.0523 16.1128L71.0508 16.1113Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1562 33.6628V35.4928L88.4523 36.3658H95.5188L92.7873 32.5933H89.0718L88.1988 33.6058L87.1562 33.6628Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5371 29.9998L89.1851 28.9048H92.7326L93.2396 29.7493L92.2256 30.8758H89.6351L88.5371 29.9998Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.447 33.6449L100.043 34.0574C99.3109 34.0574 98.6299 33.6854 98.2339 33.0704L96.4294 30.2684C96.1204 29.7899 96.4654 29.1584 97.0354 29.1584H99.1309C99.3754 29.1584 99.6064 29.2679 99.7609 29.4584L101.994 32.2004L101.447 33.6464V33.6449Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M115.857 28.8764C115.189 27.9854 115.642 26.6849 115.819 26.1734C115.947 25.8089 116.098 25.5239 116.214 25.3334L115.945 23.6819C115.005 22.9184 114.333 22.3724 113.392 21.6089L105.964 21.9509H99.9385C99.4315 21.7679 98.9245 21.5849 98.4175 21.4019C97.8115 21.3884 97.207 21.3734 96.601 21.3599C95.686 20.1914 94.771 19.0229 93.856 17.8544L91.834 17.9129C91.4245 17.7389 91.0135 17.5634 90.604 17.3894C88.0135 17.9519 85.423 18.5159 82.8325 19.0784C82.438 19.3034 82.0435 19.5284 81.6505 19.7534C79.1725 19.9499 76.6945 20.1479 74.218 20.3444C73.612 20.5034 73.0075 20.6639 72.4015 20.8229C68.065 20.9294 63.727 21.0419 59.3905 21.1604C47.8465 21.4754 36.3025 21.8324 24.7615 22.2299C24.049 22.5239 23.338 22.8179 22.6255 23.1104C21.2365 23.2379 19.807 23.3444 18.3355 23.4254C16.072 23.5499 13.8925 23.6039 11.806 23.6009C11.515 23.6009 11.3305 23.9099 11.4685 24.1664C11.7205 24.6299 11.9725 25.0949 12.2245 25.5584C12.337 25.7669 12.556 25.8959 12.793 25.8959H25.015C25.6345 25.7999 26.254 25.7039 26.8735 25.6079C29.914 25.5419 32.9545 25.4759 35.9965 25.4114C36.5095 25.6004 37.0585 25.7729 37.6435 25.9184C40.861 26.7164 43.7545 26.3444 45.7945 25.8344C46.189 26.0594 46.5835 26.2844 46.9765 26.5094L44.7805 27.8609C38.248 27.8039 31.7155 27.7484 25.1845 27.6914C24.283 27.8879 23.383 28.0859 22.4815 28.2824C19.7215 28.1249 16.876 28.0094 13.9495 27.9449C10.5205 27.8684 7.198 27.8684 3.9865 27.9284C3.8815 29.0699 3.9175 28.6874 3.8125 29.8289L4.6375 29.9984H5.9545V30.5834C5.9545 30.9374 6.229 31.2299 6.5815 31.2524C9.685 31.4474 12.7885 31.6424 15.892 31.8374C18.1735 31.9814 20.4565 32.1239 22.738 32.2679C32.5915 32.4884 42.4435 32.7089 52.297 32.9294C52.354 33.2384 52.4095 33.5489 52.4665 33.8579C54.043 34.1609 55.6195 34.4639 57.196 34.7654C62.659 34.7729 68.1205 34.7789 73.5835 34.7864C74.7385 35.1809 75.892 35.5754 77.047 35.9684C78.6805 36.5309 79.8985 37.4714 81.532 38.0339C83.5585 38.0759 86.0005 37.7414 88.0285 37.7834H101.839C102.726 37.2914 103.614 36.7979 104.5 36.3059L105.852 36.4754C109.483 35.0489 113.116 33.6224 116.748 32.1959C116.791 31.7729 116.838 31.3469 116.886 30.9179C116.937 30.4709 116.989 30.0284 117.043 29.5919C116.31 29.4164 115.977 29.0354 115.855 28.8734L115.857 28.8764ZM88.4515 36.3659L87.157 35.4929V33.6629L88.1995 33.6059L89.0725 32.5919H92.7895L95.521 36.3644H88.4545L88.4515 36.3659ZM101.448 33.6449L100.044 34.0574C99.3115 34.0574 98.6305 33.6854 98.2345 33.0704L96.43 30.2684C96.121 29.7899 96.466 29.1584 97.036 29.1584H99.1315C99.376 29.1584 99.607 29.2679 99.7615 29.4584L101.995 32.2004L101.448 33.6464V33.6449Z",
    fill: "#FAFAFB"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M101.447 33.6449L102.868 32.9309L105.176 33.8879L108.668 32.1989H116.749",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinaryRifle);
export default __webpack_public_path__ + "static/media/Binary Rifle.024d90ebb5a67d3c91158340441ef936.svg";
export { ForwardRef as ReactComponent };